
import { fetchToken } from "../../../common/FetchCookie"
import { SUBSCRIPTION_DETAILS_EMPLOYER, SUBSCRIPTIONS_TOPUP } from "../../../common/URLs"
// import { SUBSCRIPTION_DETAILS_EMPLOYER, SUBSCRIPTIONS_TOPUP } from "../../common/URLs"

export const fetchSubscriptionTopUp = async () => {
  try {
    const token = await fetchToken()
    const response = await fetch(SUBSCRIPTIONS_TOPUP, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `HTTP error! Status: ${response.status}`)
    }
    const data = await response.json()
    return data.response || []
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}

export const addSubscriptionTopUp = async (newSubscription) => {
  try {
    const token = await fetchToken()
    const response = await fetch(SUBSCRIPTIONS_TOPUP, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newSubscription),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error adding subscription: ${response.statusText}`)
    }
    const data = await response.json()
    return data.response || data
  } catch (error) {
    console.error("Add error:", error)
    throw error
  }
}

export const updateSubscriptionTopUp = async (id, updateSubscriptiondata) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${SUBSCRIPTIONS_TOPUP}/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateSubscriptiondata),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error updating: ${response.statusText}`)
    }
    const data = await response.json()
    return data.response || data
  } catch (error) {
    console.error("Update error:", error)
    throw error
  }
}

export const deleteSubscriptionTopUp = async (id) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${SUBSCRIPTIONS_TOPUP}/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.response?.msg || `Error deleting: ${response.statusText}`)
    }
    return { success: true, id }
  } catch (error) {
    console.error("Delete error:", error)
    throw error
  }
}

export const fetchEmployerSubscription = async (page = 1) => {
  const url = `${SUBSCRIPTION_DETAILS_EMPLOYER}?page=${page}`
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const data = await response.json()
    return {
      data: data.response.data || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    }
  } catch (error) {
    console.error("API Error:", error)
    throw error
  }
}
